import { motion } from "framer-motion";
import Reveal from "@/components/Reveal";
import { FRACTIONAL } from "@/content";

const EASE = [0.22, 1, 0.36, 1];

export default function NinetyDayTimeline() {
  return (
    <div data-testid="fractional-timeline">
      <Reveal className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="eyebrow-blue mb-4">Illustrative Engagement</p>
          <h3 className="font-display text-2xl sm:text-3xl font-bold tracking-[-0.03em] text-white">
            What the first 90 days typically look like
          </h3>
        </div>
        <span className="font-mono text-xs tracking-[0.25em] text-slate-500">FOCUS → PIPELINE → MOMENTUM</span>
      </Reveal>

      <div className="relative mt-12">
        <div className="absolute left-[7px] top-2 bottom-2 w-px bg-white/10 lg:left-0 lg:right-0 lg:top-[7px] lg:bottom-auto lg:h-px lg:w-auto" aria-hidden="true" />
        <motion.div
          className="absolute left-[7px] top-2 w-px origin-top bg-gradient-to-b from-electric to-gold lg:hidden"
          style={{ height: "calc(100% - 16px)" }}
          initial={{ scaleY: 0 }}
          whileInView={{ scaleY: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 2.2, ease: EASE }}
          aria-hidden="true"
        />
        <motion.div
          className="absolute left-0 top-[7px] hidden h-px w-full origin-left bg-gradient-to-r from-electric to-gold lg:block"
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 2.2, ease: EASE }}
          aria-hidden="true"
          data-testid="fractional-timeline-progress"
        />

        <ol className="grid gap-10 lg:grid-cols-3 lg:gap-12">
          {FRACTIONAL.timeline.map((t, i) => (
            <motion.li
              key={t.phase}
              className="relative pl-10 lg:pl-0 lg:pt-10"
              data-testid={`fractional-timeline-phase-${i + 1}`}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: 0.5 + i * 0.6, ease: EASE }}
            >
              <span
                className="absolute left-0 top-0 flex h-[15px] w-[15px] items-center justify-center rounded-full border border-gold bg-navy lg:top-0"
                aria-hidden="true"
              >
                <span className="h-[5px] w-[5px] rounded-full bg-gold" />
              </span>
              <div className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.25em]">
                <span className="text-gold">0{i + 1}</span>
                <span className="text-slate-500">{t.days}</span>
              </div>
              <p className="mt-4 font-display text-xl font-bold tracking-[-0.03em] text-white">{t.phase}</p>
              <p className="mt-1 text-sm text-electric/85 leading-snug">{t.headline}</p>
              <ul className="mt-5 space-y-2.5">
                {t.outcomes.map((o) => (
                  <li key={o} className="flex gap-3 text-sm text-slate-400 leading-relaxed">
                    <span className="mt-[8px] h-1 w-1 shrink-0 rounded-full bg-gold/70" aria-hidden="true" />
                    {o}
                  </li>
                ))}
              </ul>
            </motion.li>
          ))}
        </ol>
      </div>

      <Reveal delay={0.2}>
        <p className="mt-10 max-w-2xl font-mono text-[11px] leading-relaxed tracking-wider text-slate-500">
          Illustrative only. Every engagement is shaped around your market, your team and the goals we
          agree together.
        </p>
      </Reveal>
    </div>
  );
}
